import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";

type propsType = {
  title: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleConfirm: Function;
  topic: string;
};

export default function AlertDialog(props: propsType) {
  const { title, topic, isOpen, setIsOpen, handleConfirm } = props;

  const handleClose = () => {
    setIsOpen(false);
  };
  function handleAgree() {
    handleClose();
    handleConfirm();
  }

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            width: "100%",
            overflowWrap: "break-word",
            wordWrap: "break-word",
          }}
        >
          {title}
          <b>{topic}</b>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAgree}
            variant="contained"
            color="error"
            // onClick={() => handleTrash(customOptions)}
            // disabled={trashState}
            startIcon={<DeleteIcon />}
          >
            Yes
          </Button>
          <Button onClick={handleClose} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
